import { 
  Component, 
  OnInit, 
  Inject, 
  ViewChild, 
  ViewContainerRef, 
  AfterViewInit 
} from '@angular/core';
import { 
  ModalService,
  ComponentResolverService 
} from './services';
import { 
  IModalService 
} from './interfaces';
export class ModalComponent implements OnInit, AfterViewInit {

   wrapper;
/**
 * @param {?} _modalService
 */
constructor(
private _modalService: IModalService) {}
/**
 * @return {?}
 */
public ngOnInit(): void {
  }
/**
 * @return {?}
 */
public modalService(): IModalService {
    return this._modalService;
  }
/**
 * Initializes the modal service with this component
 * as the wrapper element
 * @return {?}
 */
public ngAfterViewInit() {
    this._modalService.setWrapper(this.wrapper);
  }
/**
 * Sets the visibility of the modal
 * @param {?} isVisible
 * @return {?}
 */
public setVisibility(isVisible: boolean): void {
    this._modalService.setVisibility(isVisible);
  }
/**
 * Click event bound to the overlay which causes the modal to close.
 * @param {?} event
 * @return {?}
 */
public overlayClick(event: any) {
    this._modalService.overlayClick();
  }
/**
 * Click handler which calls the modal service's close method.
 * @return {?}
 */
public close(): void {
    this._modalService.close();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sg-modal',
  //template: `<div [hidden]="!modalService().visible"><div class="container"><div class="modal"><div class="wrapper" #wrapper><div class="close" (click)="close()"><span class="ti-close"></span></div></div><div class="buttons"><button [hidden]="!button.visible" *ngFor="let button of modalService().buttons.toArray()" class="{{button.class}}" (click)="button.action()">{{button.text}}</button></div></div><app-overlay (onClick)="overlayClick($event)"></app-overlay></div></div>`,
  template: `
    <div [hidden]='!modalService().visible' 
      class='parent {{modalService().additionalClasses}}' 
      [class.open]='modalService().visible'>
  
      <div class='container'>
        <div class='modal' >
          <div class='wrapper' #wrapper>

            <!-- modal contents are rendered here -->

            <div class='close' (click)='close()'>
              <span class='ti-close'></span>
            </div>

          </div>

          <div class='buttons'>
            <button 
              [hidden]='!button.visible'
              *ngFor='let button of modalService().buttons.toArray()' 
              class='{{button.class}}' (click)='button.action()'>
              {{button.text}}
            </button>
          </div>
      
        </div>

        <app-overlay
          (onClick)='overlayClick($event)'>
        </app-overlay>
      </div>
    </div>
  `,
  //styles: [`.container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;width:100%;position:fixed;top:0;left:0}.modal{min-height:3em;-ms-flex-item-align:center;align-self:center;background-color:#e6e7e8;border:1px solid #333;border-radius:2px;padding:1em;width:85vw;max-height:75vh;-webkit-box-shadow:0 0 .5em rgba(0,0,0,.5);box-shadow:0 0 .5em rgba(0,0,0,.5);z-index:9999}.modal,.wrapper{position:relative}.buttons,.close{position:absolute}.close{top:0;right:0;cursor:pointer;z-index:9999;color:#000;padding:.5em .5em .25em}.close:hover{background-color:rgba(220,221,222,.9);color:#333}.buttons{height:auto;bottom:0;left:0;width:100%;padding:1em}.modal-button-align-left{float:left}.modal-button-align-right{float:right}.modal-button{font-size:1.2em;padding:.15em .5em .25em;margin:.25em;cursor:pointer;vertical-align:top;min-height:2em;min-width:4em}.modal-button-success{background-color:#58bb76;color:#fffefd;border:1px solid #2a854d}.modal-button-success:hover{background-color:#81ab80}.modal-button-primary{background-color:#1db0ed;color:#fffefd;border:1px solid #1582b2}.modal-button-primary:hover{background-color:#099cd9}.modal-button-warn{background-color:#ffb82e;color:#333;border:1px solid #e67c00}.modal-button-warn:hover{background-color:#e5a712;color:#000}.modal-button-normal{background-color:#d8d8d8;color:#333;border:1px solid #646464}.modal-button-normal:hover{background-color:#b4b4b4;color:#555}`]
  styles: [`
    .container {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
          -ms-flex-pack: center;
              justify-content: center;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      height: 100%;
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
    }

    .modal {
      position: relative;
      min-height: 3em;
      -ms-flex-item-align: center;
          align-self: center;
      background-color: rgb(230, 231, 232);
      border: 1px solid #333;
      border-radius: 2px;
      padding: 1em;
      width: 85vw;
      max-height: 75vh;
      -webkit-box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
              box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
      z-index: 9999;
    }
    .modal-scroll-x .modal {
      overflow-x: scroll;
    }
    .modal-scroll-y .modal {
      overflow-y: scroll;
    }
    .modal-scroll .modal {
      overflow: scroll;
    }

    .wrapper {
      position: relative;
    }

    .close {
      position: absolute;
      padding: 0.5em 0.5em 0.25em 0.5em;
      top: 0em;
      right: 0em;
      cursor: pointer;
      z-index: 9999;
      color: #000;
    }

    .close:hover {
      background-color: rgba(220, 221, 222, 0.9);
      color: #333;
    }

    .buttons {
      position: absolute;
      height: auto;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 1em;
    }


    .modal-button-align-left {
      float: left;
    }

    .modal-button-align-right {
      float: right;
    }

    /**
     * Generic button styling
     */
    .modal-button {
      font-size: 1.2em;
      padding: 0.15em 0.5em 0.25em 0.5em;
      margin: 0.25em;
      cursor: pointer;
      vertical-align: top;
      min-height: 2em;
      min-width: 4em;
    }

    /**
     * Success button type color
     */
    .modal-button-success {
      background-color: #58BB76;
      color: rgb(255, 254, 253);
      border: 1px solid #2A854D;  
    }
    .modal-button-success:hover {
      background-color: #81AB80;
    }

    /**
     * Primary button type color
     */
    .modal-button-primary {
      background-color: rgb(29, 176, 237);
      color: rgb(255, 254, 253);
      border: 1px solid rgb(21, 130, 178);  
    }
    .modal-button-primary:hover {
      background-color: rgb(9, 156, 217);
    }

    /**
     * Warning button type color
     */
    .modal-button-warn {
      background-color: #FFB82E;
      color: #333;
      border: 1px solid #E67C00;  
    }
    .modal-button-warn:hover {
      background-color: #E5A712;
      color: #000;
    }

    /**
     * Normal button type color
     */
    .modal-button-normal {
      background-color: #D8D8D8;
      color: #333;
      border: 1px solid #646464;  
    }
    .modal-button-normal:hover {
      background-color: #B4B4B4;
      color: #555;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [ModalService, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'wrapper': [{ type: ViewChild, args: ['wrapper', {read: ViewContainerRef}, ] },],
};
}

function ModalComponent_tsickle_Closure_declarations() {
/** @type {?} */
ModalComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalComponent.ctorParameters;
/** @type {?} */
ModalComponent.propDecorators;
/** @type {?} */
ModalComponent.prototype.wrapper;
/** @type {?} */
ModalComponent.prototype._modalService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
